import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import "../staff/staff.css";
import "./internal.css";

/*
 * Amend a form that is already in the EMR: a reason (required, printed on the
 * amendment's PDF), then a new draft with the same answers opens.
 *   open, busy, error, onClose(), onSubmit(reason)
 */
export default function AmendDialog({ open, busy, error, onClose, onSubmit, title }) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);
  const trimmed = reason.trim();
  return (
    <Dialog open={!!open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm" aria-labelledby="fwi-amend-title">
      <div className="fws fwi-dlg" data-testid="amend-dialog">
        <h2 id="fwi-amend-title" className="fws-section-title">Amend {title || "this form"}</h2>
        <p className="fws-help">
          This form is in the EMR, so it can't be edited. An amendment is a new document that replaces it: it starts with the
          same answers, and its PDF says which document it replaces and why.
        </p>
        <div className="fws-field">
          <label className="fws-label" htmlFor="fwi-amend-reason">Reason for the amendment</label>
          <textarea id="fwi-amend-reason" className="fws-textarea" maxLength={500} value={reason} autoFocus
            placeholder="e.g. Wrong pressure recorded; corrected to 9 cmH2O" onChange={(e) => setReason(e.target.value)} />
          <span className="fws-help">{trimmed.length}/500. Printed on the amendment.</span>
        </div>
        {error && <div className="fws-alert fws-alert-error" role="alert">{error}</div>}
        <div className="fws-row" style={{ justifyContent: "flex-end" }}>
          <button type="button" className="fws-btn fws-btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="button" className="fws-btn fws-btn-primary" disabled={!trimmed || busy} onClick={() => onSubmit(trimmed)}>
            {busy ? "Creating…" : "Create amendment"}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
